import type { McpAppDto } from '@lib/dto/mcp.dto'
import { Badge } from '@/components/ui/badge'

/** Which AI app is asking: the name it gives itself, where it signs in from, and whether PixelSign recognizes it. */
export function AppIdentity({ app }: { app: McpAppDto }) {
  return (
    <div className="space-y-1 rounded-lg border border-border bg-subtle px-3 py-2">
      <div className="flex flex-wrap items-center gap-2">
        <span className="text-title font-semibold">{app.name}</span>
        {app.recognized ? <Badge tone="success">Recognized</Badge> : <Badge tone="warning">Not recognized</Badge>}
      </div>
      <p className="font-mono text-caption break-all text-muted-foreground">{app.origin}</p>
      {app.recognized ? null : (
        <p className="text-caption text-muted-foreground">
          Apps PixelSign doesn&apos;t recognize can&apos;t get live changes or staff powers.
        </p>
      )}
    </div>
  )
}
